import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';
import classnames from 'classnames';
import config from '../../../../../config';
import DatePicker from '../../../../common/DatePicker';
import Days from './days';
import Icon, { GLYPHS } from '../../../../common/icon';
import * as propTypes from '../propTypes';

const SelectDay = ({
  day,
  days,
  selectDay,
  prevWeek,
  nextWeek,
  minDate,
  maxDate,
  startOfWeek,
  loading,
  datesMarkedDisabled,
  daysOfWeekMarkedDisabled,
}) => {
  const selectedDay = moment(day).format(config.fullDateFormat);
  const onDatePickerChange = (date) => {
    selectDay(moment(date).format(config.dateFormatISO));
  };

  const buttonClassName = classnames('c-btn c-btn--blank u-type--light u-ph-', {
    'is-disabled': loading,
  });

  return (
    <div>
      <div className="layout--middle layout--flush u-pb--">
        <div
          className="layout__item u-1/4-medium-and-down u-3/8-medium-and-up u-text-right
            c-appointment-details-day-arrow"
        >
          <button
            className={`${buttonClassName} u-hidden-for-large-and-down`}
            type="button"
            onClick={() => prevWeek(6)}
            disabled={moment(startOfWeek).subtract(6, 'weeks').isBefore(minDate)}
          >
            <Icon glyph={GLYPHS.arrowLeft} className="c-icon" />
            6
          </button>
          <button
            className={`${buttonClassName} u-hidden-for-medium-and-down`}
            type="button"
            onClick={() => prevWeek(4)}
            disabled={moment(startOfWeek).subtract(4, 'weeks').isBefore(minDate)}
          >
            <Icon glyph={GLYPHS.arrowLeft} className="c-icon" />
            4
          </button>
          <button
            className={`${buttonClassName} u-hidden-for-medium-and-down`}
            type="button"
            onClick={() => prevWeek(2)}
            disabled={moment(startOfWeek).subtract(2, 'weeks').isBefore(minDate)}
          >
            <Icon glyph={GLYPHS.arrowLeft} className="c-icon" />
            2
          </button>
          <button
            className={buttonClassName}
            type="button"
            onClick={() => prevWeek(1)}
            disabled={moment(startOfWeek).subtract(1, 'weeks').isBefore(minDate)}
          >
            <Icon glyph={GLYPHS.arrowLeft} className="c-icon" />
            -1 Week
          </button>
        </div>
        <div
          className="layout__item u-1/2-medium-and-down u-2/8-medium-and-up u-text-center
            u-type--semibold c-heading u-fontsize-small"
          data-automation-id="text:datePicker:SelectedDay"
        >
          { selectedDay }
          <DatePicker
            component="button"
            onChange={onDatePickerChange}
            startDate={minDate.toDate()}
            endDate={maxDate.toDate()}
            datesMarkedDisabled={datesMarkedDisabled}
            daysOfWeekMarkedDisabled={daysOfWeekMarkedDisabled}
            day={day}
          />
        </div>
        <div
          className="layout__item u-1/4-medium-and-down u-3/8-medium-and-up u-type--normal
            c-appointment-details-day-arrow"
        >
          <button
            className={buttonClassName}
            type="button"
            onClick={() => nextWeek(1)}
            disabled={moment(startOfWeek).add(1, 'weeks').isAfter(maxDate)}
            data-automation-id="next-one-week"
          >
            +1 Week
            <Icon glyph={GLYPHS.arrowRight} className="c-icon" />
          </button>
          <button
            className={`${buttonClassName} u-hidden-for-medium-and-down`}
            type="button"
            onClick={() => nextWeek(2)}
            disabled={moment(startOfWeek).add(2, 'weeks').isAfter(maxDate)}
          >
            2
            <Icon glyph={GLYPHS.arrowRight} className="c-icon" />
          </button>
          <button
            className={`${buttonClassName} u-hidden-for-medium-and-down`}
            type="button"
            onClick={() => nextWeek(4)}
            disabled={moment(startOfWeek).add(4, 'weeks').isAfter(maxDate)}
          >
            4
            <Icon glyph={GLYPHS.arrowRight} className="c-icon" />
          </button>
          <button
            className={`${buttonClassName} u-hidden-for-large-and-down`}
            type="button"
            onClick={() => nextWeek(6)}
            disabled={moment(startOfWeek).add(6, 'weeks').isAfter(maxDate)}
          >
            6
            <Icon glyph={GLYPHS.arrowRight} className="c-icon" />
          </button>
        </div>
      </div>
      <Days
        selected={day}
        days={days}
        selectDay={selectDay}
        loading={loading}
      />
    </div>
  );
};
SelectDay.propTypes = {
  day: PropTypes.string,
  days: propTypes.days,
  minDate: PropTypes.instanceOf(moment).isRequired,
  maxDate: PropTypes.instanceOf(moment).isRequired,
  startOfWeek: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]),
  selectDay: PropTypes.func,
  prevWeek: PropTypes.func,
  nextWeek: PropTypes.func,
  loading: PropTypes.bool,
  datesMarkedDisabled:
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])),
  daysOfWeekMarkedDisabled: PropTypes.arrayOf(PropTypes.number),
};
SelectDay.defaultProps = {
  day: '',
  days: [],
  startOfWeek: null,
  selectDay: () => null,
  prevWeek: () => null,
  nextWeek: () => null,
  loading: false,
  datesMarkedDisabled: [],
  daysOfWeekMarkedDisabled: [],
};

export default SelectDay;
